import React, { createContext, useEffect, useState } from "react";

export const LayoutContext = createContext();

const LayoutProvider = ({ children }) => {
    const [collapsed, setCollapsed] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (window && window.innerWidth < 700) {
            setIsMobile(true);
        }
    }, []);

    return (
        <LayoutContext.Provider
            value={{
                collapsed,
                setCollapsed,
                isMobile,
                setIsMobile,
            }}
        >
            {children}
        </LayoutContext.Provider>
    );
};

export default LayoutProvider;
